import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { Observable, of } from "rxjs";
import { IConfigurationFile, IConfigurationUpdate, IConfigurationUpdateRequest, IDeviceInfo, ISetAutoUpdateModeRequest } from "../cameraCommunicationServer.service";

@Injectable({
    providedIn: 'root'
})
export class CameraCommunicationServerService {
    constructor(
        private readonly http: HttpClient
    ) { }

    getDeviceInfo(serial: string): Observable<IDeviceInfo> {
        if (!serial) {
            return of(null);
        }

        return this.http.get<IDeviceInfo>(`/api/communicationServer/device/${serial}/info`);
    }

    getConfigurationUpdateHistory(deviceId: number): Observable<IConfigurationUpdate[]> {
        return this.http.get<IConfigurationUpdate[]>(`/api/communicationServer/device/${deviceId}/configHistory`);
    }


    postConfigUpdate(update: IConfigurationUpdateRequest): Observable<any> {
        return this.http.post(`/api/communicationServer/config`, update);
    }

    setAutoUpdateMode(request: ISetAutoUpdateModeRequest): Observable<any> {
        return this.http.post(`/api/communicationServer/autoUpdateMode`, request);
    }

    getAvailableConfigFiles(deviceTypeId: number, includeArchived: boolean): Observable<IConfigurationFile[]> {
        const params = getOptionsQueryParams({ includeArchived });

        return this.http.get<IConfigurationFile[]>(`/api/communicationServer/config/${deviceTypeId}/files`, params)

    }

}
